import React from 'react';
import { Youtube, Shield, Zap, Users } from 'lucide-react';

const categories = [
  {
    title: "Gaming Content",
    examples: ["Let's Play", "Game Reviews", "Tutorials"],
    description: "Tags optimized for gaming content and streaming."
  },
  {
    title: "Educational Videos",
    examples: ["How-to Guides", "Tutorials", "Courses"],
    description: "Tags that help learners find your educational content."
  },
  {
    title: "Entertainment",
    examples: ["Vlogs", "Comedy", "Reactions"],
    description: "Tags for entertainment and lifestyle content."
  }
];

const tips = [
  {
    icon: Youtube,
    title: "Use Relevant Tags",
    content: "Choose tags that accurately describe your content."
  },
  {
    icon: Shield,
    title: "Avoid Tag Stuffing",
    content: "Focus on quality over quantity in your tags."
  },
  {
    icon: Zap,
    title: "Stay Current",
    content: "Include trending and timely tags when relevant."
  },
  {
    icon: Users,
    title: "Know Your Audience",
    content: "Use tags that your target viewers search for."
  }
];

export default function YouTubeGuide() {
  return (
    <section className="py-20 bg-red-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Complete Guide to YouTube Tags
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {categories.map((category, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">{category.title}</h3>
              <ul className="space-y-2 mb-4">
                {category.examples.map((example, i) => (
                  <li key={i} className="text-red-600">{example}</li>
                ))}
              </ul>
              <p className="text-gray-600">{category.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-white p-8 rounded-lg shadow-md">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
            Best Practices for YouTube Tags
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {tips.map((tip, index) => (
              <div key={index} className="text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-red-100 mb-4">
                  <tip.icon className="w-6 h-6 text-red-600" />
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-2">{tip.title}</h4>
                <p className="text-gray-600">{tip.content}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}